import React from "react";
import SideBanner from "components/layout/SideBanner";
import { useAdesao } from "features/adesao/hooks/useAdesao";

import { Body, Container, Content } from "./AdesaoPage.styles";

const AdesaoPage = (): JSX.Element => {
  const { step, header, stepView, steppers } = useAdesao();

  return (
    <Container>
      <SideBanner activated={step} header={header} steppers={steppers} />
      <Content>
        <Body>{stepView}</Body>
      </Content>
    </Container>
  );
};

export default AdesaoPage;
